import { createSlice } from "@reduxjs/toolkit";
import { getSubscribedAccounts } from "./_subscribedAccountsAction";

const initialState: any = {
  data: [],
  isLoading: true,
  isSuccess: false,
  responseCode: null,
  responseMessage: '',
  totalRecord: 0,
};

export const subscriptionAccounts = createSlice({
  name: "subscriptionAccounts",
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getSubscribedAccounts.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
      })
      .addCase(getSubscribedAccounts.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.data = payload.data||[];
        state.responseMessage = payload.responseMessage;
        state.responseCode = payload.responseCode;
        state.totalRecord = payload.totalRecord || 0;        
      })
      .addCase(getSubscribedAccounts.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.errorMessage = payload;
      })
  },
});
